import React from "react";


function Legal() {
  const legalData = [
    {
      image: "/assets/images/legal-1.jpg",
      title: "Certificate of Incorporation",
    },
    {
      image: "/assets/images/legal-2.jpg",
      title: "Income Tax",
    },
    {
      image: "/assets/images/legal-3.jpg",
      title: "PAN",
    },
    {
      image: "/assets/images/legal-4.jpg",
      title: "GST",
    },
    {
      image: "/assets/images/legal-5.jpg",
      title: "UDYAM Aadhar",
    },
    {
      image: "/assets/images/legal-6.png",
      title: "UDYAM Aadhar",
    },
    {
      image: "/assets/images/legal-7.jpg",
      title: "Certificate of Registration",
    },
  ];
  return (
    <>
      <section className="legal-section">
        <div className="container">
          <div className="legal-heading">
            <h2>Legal</h2>
          </div>

          <div className="legal-grid">
            {legalData.map((item, index) => (
              <div className="legal-card" key={index}>
                <img src={item.image} alt={item.title} />
                <h5>{item.title}</h5>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Legal;
